import { render, staticRenderFns } from "./list_customer.vue?vue&type=template&id=e4fe1cde&scoped=true"
import script from "./list_customer.vue?vue&type=script&lang=js"
export * from "./list_customer.vue?vue&type=script&lang=js"
import style0 from "./list_customer.vue?vue&type=style&index=0&id=e4fe1cde&prod&lang=css&scoped=true"
import style1 from "./list_customer.vue?vue&type=style&index=1&id=e4fe1cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fe1cde",
  null
  
)

export default component.exports